import BaseAPIService from '../base/base-api-service';
import CategoryModel from 'src/model/category.model';
import env from 'src/shared/env';

class CategoryService extends BaseAPIService<CategoryModel> {
  private basicURL: string = env.REACT_APP_BASE_API_URL;
  public categoriesEndpoint: string = '/navapp/v1/category';

  constructor() {
    super(CategoryModel);
  }

  private buildSubcategoriesEndpoint(categoryId: string) {
    return `${this.basicURL}navapp/v1/category/${categoryId}`;
  }

  public getCategories() {
    return new Promise((resolve, reject) => {
      this.getOneByParams(this.categoriesEndpoint)
        .then((res: any) => {
          resolve(res.categories.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  public getCategoryData(categoryId: string) {
    const endpoint: string = this.buildSubcategoriesEndpoint(categoryId);

    return new Promise((resolve, reject) => {
      this.getOneByParams(endpoint)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

const categoryServiceInstance = new CategoryService();
Object.freeze(categoryServiceInstance);

export default categoryServiceInstance;
